
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1505Dialog extends Serenity.EntityDialog<Report_1505Row, any> {
        protected getFormKey() { return Report_1505Form.formKey; }
        protected getIdProperty() { return Report_1505Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1505Row.localTextPrefix; }
        protected getNameProperty() { return Report_1505Row.nameProperty; }
        protected getService() { return Report_1505Service.baseUrl; }
        protected getDeletePermission() { return Report_1505Row.deletePermission; }
        protected getInsertPermission() { return Report_1505Row.insertPermission; }
        protected getUpdatePermission() { return Report_1505Row.updatePermission; }

        protected form = new Report_1505Form(this.idPrefix);

    }
}